import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { setRaceOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'

export function* getRaceOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getRaceOptions,
    ])
    const { entity } = response
    yield put(setRaceOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRaceOptions() error: ${e}`))
  }
}

export function* getRaceOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRaceOptions)
}
